
import { defineComponent } from "vue";
import LayoutComponent from "./component.vue";
import { StartDrag } from "@/utils/PanelHelpers";
import { usePanelStore } from "@/stores/panelStore";
import { storeToRefs } from "pinia";
import { usePvwStore } from "@/stores/ssaStore/pvw";
import Handle from "./handle.vue";
import { useActiveStore } from "@/stores/ssaStore/active";
export default defineComponent({
	setup() {
		const pvw = usePvwStore();
		const panelStore = usePanelStore();
		const { visualizers, activeVisualizer } = storeToRefs(panelStore);
		const { view: activeView } = storeToRefs(useActiveStore());
		return { panelStore, visualizers, activeVisualizer, pvw, activeView };
	},
	name: "StackContainer",
	data() {
		return {
			activeTab: 0,
			uid: this.$uuid4()
		};
	},
	beforeCreate() {
		// this.uid = this.$uuid4();
	},
	mounted() {
		(this.$refs[this.uid] as HTMLElement).style.flexDirection = this.type;
	},
	props: {
		children: {
			type: Array as () => Array<LayoutType>,
			default: () => []
		},
		componentName: {
			type: String,
			default: ""
		},
		id: {
			type: Number,
			default: null
		},
		type: {
			type: String,
			default: ""
		},
		component: {
			type: String,
			default: "LayoutComponent"
		},
		componentState: {
			type: Object as () => ComponentStateType,
			default: () => {
				return { flex: 1, color: "#fff" };
			}
		}
	},
	methods: {
		async moveComponent(payload: { type: string; id: number; dropEl: number }) {
			await this.panelStore.MOVE_COMPONENT(payload);
			window.dispatchEvent(new Event("resize"));
		},
		async removeComponent(payload: LayoutType) {
			this.panelStore.REMOVE_COMPONENT(payload);
			if (payload.componentState.viewId != null) {
				await this.pvw.PVW_REMOVE_VIEW({ viewId: payload.componentState.viewId });
			}
		},
		dragStart(e: MouseEvent, id: number) {
			const TIMEOUT = setTimeout(async () => {
				const ROOT_EL = this.$root;
				if (ROOT_EL == null) return;
				const R_EL: any = document.getElementById("app");
				const RESPONSE: { type: string; id: number; dropEl: number } = await StartDrag(
					e,
					id,
					this.$el,
					R_EL
				);
				this.moveComponent(RESPONSE);
			}, 500);
			const MOUSE_UP_LISTENER = () => {
				clearTimeout(TIMEOUT);
				removeEventListener("mouseup", MOUSE_UP_LISTENER);
			};
			addEventListener("mouseup", MOUSE_UP_LISTENER);
		}
	},
	computed: {
		panelLayout() {
			return this.panelStore.panelLayout;
		},
		stacked() {
			return this.type == "stacked";
		}
	},
	watch: {
		activeTab() {
			setTimeout(() => {
				window.dispatchEvent(new Event("resize"));
			}, 1000);
		},
		panelLayout: {
			deep: true,
			handler() {
				this.$nextTick(() => {
					if (this.activeTab > this.children.length - 1) {
						this.activeTab = this.children.length - 1;
					}
				});
			}
		}
	},
	components: {
		LayoutComponent,
		Handle
	}
});
